export const BRIDGE_STALE_AFTER_MS = 3 * 60 * 60 * 1000;

export const BRIDGE_STATUS_COLORS = { RED: '#d32f2f', AMBER: '#ed6c02' };
